
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VectorFieldEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (80 + layerIndex * 40) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawArrow = (x: number, y: number, angle: number, len: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(angle);
             ctx.beginPath();
             ctx.moveTo(-len/2, 0);
             ctx.lineTo(len/2, 0);
             ctx.lineTo(len/4, -len/4);
             ctx.moveTo(len/2, 0);
             ctx.lineTo(len/4, len/4);
             ctx.stroke();
             ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    const angle = Math.sin(x * 0.01 + curTime) + Math.cos(y * 0.01 + curTime);
                    drawArrow(x, y, angle, spacing * 0.5 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
